/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  BootstrapContractsRegistry,
  BootstrapContractsRegistryInterface,
} from "../BootstrapContractsRegistry";

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "authorizedUsers",
        type: "address[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_contract",
        type: "address",
      },
    ],
    name: "RegistryUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GOVERNOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "IDP_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REDBELLY_NODE_OPERATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REDBELLY_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "contractName",
        type: "string",
      },
    ],
    name: "getContractAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "address",
        name: "_contract",
        type: "address",
      },
    ],
    name: "register",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "registry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class BootstrapContractsRegistry__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    authorizedUsers: string[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BootstrapContractsRegistry> {
    return super.deploy(
      authorizedUsers,
      overrides || {}
    ) as Promise<BootstrapContractsRegistry>;
  }
  getDeployTransaction(
    authorizedUsers: string[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(authorizedUsers, overrides || {});
  }
  attach(address: string): BootstrapContractsRegistry {
    return super.attach(address) as BootstrapContractsRegistry;
  }
  connect(signer: Signer): BootstrapContractsRegistry__factory {
    return super.connect(signer) as BootstrapContractsRegistry__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BootstrapContractsRegistryInterface {
    return new utils.Interface(_abi) as BootstrapContractsRegistryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BootstrapContractsRegistry {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as BootstrapContractsRegistry;
  }
}
